import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Space } from "antd"
import { baseAxiosNoInfo } from "../../../tool/axios"

import '../css/RecordCheckInInterview.css'

interface data {
    interview_date: string // 回访日期
    room_cosy_level: number // 入住当天：房间舒适度 0未知（默认） 1很满意 2满意 3一般 4不满意
    room_service_level: string // 入住当天：房间服务 1倒茶水 2试穿月子服 3试穿月子鞋 4送行李，英文逗号拼接
    second_day_prop_edu: string // 入住当天：宣教 1电话 2各部门介绍 3家属餐 4停车费 5探访 6门锁 7WIFI，英文逗号拼接
    first_night_feel_level: number // 入住第2天：产妇入住第一晚的感受 0未知（默认） 1很满意 2满意 3适应中 4不习惯
    second_day_food_level: number // 入住第2天：餐食情况 0未知（默认） 1很满意 2满意 3一般 4不满意
    sleep_level: number // 入住第2天：睡眠情况 0未知（默认） 1良好 2一般 3无法入眠
    second_day_injury_level: number // 入住第2天：伤口情况 0未知（默认） 1恢复良好 2一般 3异常疼痛
    baby_level: number // 入住第2天：宝宝情况 0未知（默认） 1一切正常 2黄疸偏高 3宝宝生病 4住院未归
    in_hospital_date: string // 入住第2天：住院日期，和baby_level字段绑定的，当baby_level为4时必填
    third_day_prop_edu: string // 入住第3天：宣导 1医生查房规律告知 2妈咪课堂介绍 3产后项目安排 4宣教适当通风/活动 5宝宝黄疸情况 6体质分析安排
    third_day_injury_level: number // 入住第3天：伤口情况 0未知（默认） 1恢复良好 2一般 3异常疼痛
    breast_level: number // 入住第3天：乳房情况 0未知（默认） 1良好 2奶量多 3奶量少 4乳腺炎
    nurse_level: number // 入住第10-12天：护士/护理师 0未知（默认） 1很满意 2满意 3一般 4不满意
    room_clean_level: number // 入住第10-12天：客房保洁 0未知（默认） 1很满意 2满意 3一般 4不满意
    tenth_day_food_level: number // 入住第10-12天：营养师/餐食 0未知（默认） 1很满意 2满意 3一般 4不满意
    chankang_service_level: number // 入住第10-12天：产康服务 0未知（默认） 1很满意 2满意 3一般 4不满意
    minion_level: number // 入住第10-12天：管家 0未知（默认） 1很满意 2满意 3一般 4不满意
    doctor_level: number // 入住第10-12天：查房医生 0未知（默认） 1很满意 2满意 3一般 4不满意
    mom_class: string // 入住第17-19天：妈咪课堂上课情况
    continue_intention: string // 入住第17-19天：续住意向沟通
    tweenty_fourth_mom_recovery: string // 入住第24-26天：妈妈身体恢复情况
    tweenty_fourth_baby_sleep_grow: string // 入住第24-26天：宝睡眠、生长情况
    thirty_second_mom_recovery: string // 入住第32-34天：妈妈身体恢复情况
    thirty_second_baby_sleep_grow: string // 入住第32-34天：宝宝睡眠、生长情况
    baby_vaccine: string // 入住第32-34天：宝宝疫苗
    lochia: string // 入住第32-34天：恶露情况
    all_dep_service_level: number // 入住第32-34天：各部门服务情况 0未知（默认） 1很满意 2满意 3一般 4不满意
    expect_leave_date: string // 离所前3天：预计离所时间
    leave_before_three_prop_edu: string // 离所前3天：宣导 1体质分析 2离所宣导 3满意度调查表 4告知停车票报销，英文逗号拼接
    leave_before_three_food: string // 离所前3天：备餐 1早餐 2早茶 3午餐 4下午茶 5晚餐，英文逗号拼接
    leave_before_one_prop_edu: string // 离所前1天：离所流程宣导 1用早餐、喂奶 2宝宝物品、存奶收拾好拿到房间 3收拾好行李让工作人员搬行李 4等待客房部门查房 5带上两张门禁卡/押金条办理手续 6可带走、不可带走物品
    destination: string // 离所前1天：车送目的地址
    other_exception: string // 公共：其他异常
}

export default function () {

    const param: { id: string } = useParams()
    const [data, setData] = useState<data>()
    const [currentDay, setCuurentDay] = useState<string>('R1')

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/interview_records', {
            params: {
                check_in_id: param.id,
                interview_dic_code: currentDay
            }
        }).then((res: any) => {
            res && setData(res)
        })
    }, [currentDay])

    return <div className="modules">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 入住回访记录 */}
        <Space direction="horizontal" wrap >
            <p onClick={() => { setCuurentDay('R1') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R1' ? 'current' : ''}>入住当天</p>
            <p onClick={() => { setCuurentDay('R2') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R2' ? 'current' : ''}>入住第2天</p>
            <p onClick={() => { setCuurentDay('R3') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R3' ? 'current' : ''}>入住第3天</p>
            <p onClick={() => { setCuurentDay('R4') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R4' ? 'current' : ''}>入住第10-12天</p>
            <p onClick={() => { setCuurentDay('R5') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R5' ? 'current' : ''}>入住第17-19天</p>
            <p onClick={() => { setCuurentDay('R6') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R6' ? 'current' : ''}>入住第24-26天</p>
            <p onClick={() => { setCuurentDay('R7') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'R7' ? 'current' : ''}>入住第32-34天</p>
            <p onClick={() => { setCuurentDay('L1') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'L1' ? 'current' : ''}>离所前3天</p>
            <p onClick={() => { setCuurentDay('L2') }} style={{ cursor: 'pointer', paddingRight: 10, marginBottom: 15 }} className={currentDay === 'L2' ? 'current' : ''}>离所前1天</p>
        </Space>

        {currentDay === 'R1' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>房间舒适度：</p>
                        <p>{data?.room_cosy_level === 1 && '很满意'}</p>
                        <p>{data?.room_cosy_level === 2 && '满意'}</p>
                        <p>{data?.room_cosy_level === 3 && '一般'}</p>
                        <p>{data?.room_cosy_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>房间服务：</p>
                        <p>{data?.room_service_level && data?.room_service_level.split(',').map(el => {
                            if (el === '1') { return '倒茶水 ' }
                            if (el === '2') { return '试穿月子服 ' }
                            if (el === '3') { return '试穿月子鞋 ' }
                            if (el === '4') { return '送行李 ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宣教：</p>
                        <p>{data?.second_day_prop_edu && data?.second_day_prop_edu.split(',').map(el => {
                            if (el === '1') { return '电话 ' }
                            if (el === '2') { return '各部门介绍 ' }
                            if (el === '3') { return '家属餐 ' }
                            if (el === '4') { return '停车费 ' }
                            if (el === '5') { return '探访 ' }
                            if (el === '6') { return '门锁 ' }
                            if (el === '7') { return 'WIFI ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R2' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>产妇入住第一晚的感受：</p>
                        <p>{data?.first_night_feel_level === 0 && '未知'}</p>
                        <p>{data?.first_night_feel_level === 1 && '很满意'}</p>
                        <p>{data?.first_night_feel_level === 2 && '满意'}</p>
                        <p>{data?.first_night_feel_level === 3 && '适应中'}</p>
                        <p>{data?.first_night_feel_level === 4 && '不习惯'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>餐食情况：</p>
                        <p>{data?.second_day_food_level === 0 && '未知'}</p>
                        <p>{data?.second_day_food_level === 1 && '很满意'}</p>
                        <p>{data?.second_day_food_level === 2 && '满意'}</p>
                        <p>{data?.second_day_food_level === 3 && '一般'}</p>
                        <p>{data?.second_day_food_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>睡眠情况：</p>
                        <p>{data?.sleep_level === 0 && '未知'}</p>
                        <p>{data?.sleep_level === 1 && '良好'}</p>
                        <p>{data?.sleep_level === 2 && '一般'}</p>
                        <p>{data?.sleep_level === 3 && '无法入眠'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>伤口情况：</p>
                        <p>{data?.second_day_injury_level === 0 && '未知'}</p>
                        <p>{data?.second_day_injury_level === 1 && '恢复良好'}</p>
                        <p>{data?.second_day_injury_level === 2 && '一般'}</p>
                        <p>{data?.second_day_injury_level === 3 && '异常疼痛'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宝宝情况：</p>
                        <p>{data?.baby_level === 0 && '未知'}</p>
                        <p>{data?.baby_level === 1 && '一切正常'}</p>
                        <p>{data?.baby_level === 2 && '黄疸偏高'}</p>
                        <p>{data?.baby_level === 3 && '宝宝生病'}</p>
                        <p>{data?.baby_level === 4 && '住院未归'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>住院日期：</p>
                        <p>{data?.in_hospital_date}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R3' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>宣导：</p>
                        <p>{data?.third_day_prop_edu && data?.third_day_prop_edu.split(',').map(el => {
                            if (el === '1') { return '医生查房规律告知 ' }
                            if (el === '2') { return '妈咪课堂介绍 ' }
                            if (el === '3') { return '产后项目安排 ' }
                            if (el === '4') { return '宣教适当通风/活动' }
                            if (el === '5') { return '宝宝黄疸情况' }
                            if (el === '6') { return '体质分析安排 ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>伤口情况：</p>
                        <p>{data?.third_day_injury_level === 0 && '未知'}</p>
                        <p>{data?.third_day_injury_level === 1 && '恢复良好'}</p>
                        <p>{data?.third_day_injury_level === 2 && '一般'}</p>
                        <p>{data?.third_day_injury_level === 3 && '异常疼痛'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>乳房情况：</p>
                        <p>{data?.breast_level === 1 && '良好'}</p>
                        <p>{data?.breast_level === 2 && '奶量多'}</p>
                        <p>{data?.breast_level === 3 && '奶量少'}</p>
                        <p>{data?.breast_level === 4 && '乳腺炎'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>其他异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R4' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>护士/护理师：</p>
                        <p>{data?.nurse_level === 0 && '未知'}</p>
                        <p>{data?.nurse_level === 1 && '很满意'}</p>
                        <p>{data?.nurse_level === 2 && '满意'}</p>
                        <p>{data?.nurse_level === 3 && '一般'}</p>
                        <p>{data?.nurse_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>客房保洁：</p>
                        <p>{data?.room_clean_level === 0 && '未知'}</p>
                        <p>{data?.room_clean_level === 1 && '很满意'}</p>
                        <p>{data?.room_clean_level === 2 && '满意'}</p>
                        <p>{data?.room_clean_level === 3 && '一般'}</p>
                        <p>{data?.room_clean_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>营养师/餐食：</p>
                        <p>{data?.tenth_day_food_level === 0 && '未知'}</p>
                        <p>{data?.tenth_day_food_level === 1 && '很满意'}</p>
                        <p>{data?.tenth_day_food_level === 2 && '满意'}</p>
                        <p>{data?.tenth_day_food_level === 3 && '一般'}</p>
                        <p>{data?.tenth_day_food_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>产康服务：</p>
                        <p>{data?.chankang_service_level === 0 && '未知'}</p>
                        <p>{data?.chankang_service_level === 1 && '很满意'}</p>
                        <p>{data?.chankang_service_level === 2 && '满意'}</p>
                        <p>{data?.chankang_service_level === 3 && '一般'}</p>
                        <p>{data?.chankang_service_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>管家服务：</p>
                        <p>{data?.minion_level === 0 && '未知'}</p>
                        <p>{data?.minion_level === 1 && '很满意'}</p>
                        <p>{data?.minion_level === 2 && '满意'}</p>
                        <p>{data?.minion_level === 3 && '一般'}</p>
                        <p>{data?.minion_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>查房医生：</p>
                        <p>{data?.doctor_level === 0 && '未知'}</p>
                        <p>{data?.doctor_level === 1 && '很满意'}</p>
                        <p>{data?.doctor_level === 2 && '满意'}</p>
                        <p>{data?.doctor_level === 3 && '一般'}</p>
                        <p>{data?.doctor_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R5' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>妈咪课堂上课情况：</p>
                        <p>{data?.mom_class}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>续住意向沟通：</p>
                        <p>{data?.continue_intention}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>其他异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R6' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>妈妈身体恢复情况：</p>
                        <p>{data?.tweenty_fourth_mom_recovery}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宝宝睡眠、生长情况：</p>
                        <p>{data?.tweenty_fourth_baby_sleep_grow}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'R7' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>妈妈身体恢复情况：</p>
                        <p>{data?.thirty_second_mom_recovery}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宝宝睡眠、生长情况：</p>
                        <p>{data?.thirty_second_baby_sleep_grow}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宝宝疫苗：</p>
                        <p>{data?.baby_vaccine}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>恶露情况：</p>
                        <p>{data?.lochia}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>各部门服务情况：</p>
                        <p>{data?.all_dep_service_level === 0 && '未知'}</p>
                        <p>{data?.all_dep_service_level === 1 && '很满意'}</p>
                        <p>{data?.all_dep_service_level === 2 && '满意'}</p>
                        <p>{data?.all_dep_service_level === 3 && '一般'}</p>
                        <p>{data?.all_dep_service_level === 4 && '不满意'}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'L1' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>预计离所时间：</p>
                        <p>{data?.expect_leave_date}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>宣导：</p>
                        <p>{data?.leave_before_three_prop_edu && data?.leave_before_three_prop_edu.split(',').map(el => {
                            if (el === '1') { return '体质分析 ' }
                            if (el === '2') { return '离所宣导 ' }
                            if (el === '3') { return '满意度调查表 ' }
                            if (el === '4') { return '告知停车票报销 ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备餐：</p>
                        <p>{data?.leave_before_three_food && data?.leave_before_three_food.split(',').map(el => {
                            if (el === '1') { return '早餐 ' }
                            if (el === '2') { return '早茶 ' }
                            if (el === '3') { return '午餐 ' }
                            if (el === '4') { return '下午茶 ' }
                            if (el === '5') { return '晚餐 ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}

        {currentDay === 'L2' && <div>
            <div>
                <h4>回访时间：{data?.interview_date}</h4>
                <div>
                    <Space>
                        <p>预计离所时间：</p>
                        <p>{data?.expect_leave_date}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>离所流程宣导：</p>
                        <p>{data?.leave_before_one_prop_edu && data?.leave_before_one_prop_edu.split(',').map(el => {
                            if (el === '1') { return '用早餐、喂奶 ' }
                            if (el === '2') { return '宝宝物品、存奶收拾好拿到房间 ' }
                            if (el === '3') { return '收拾好行李让工作人员搬行李 ' }
                            if (el === '4') { return '等待客房部门查房 ' }
                            if (el === '5') { return '带上两张门禁卡/押金条办理手续 ' }
                            if (el === '6') { return '可带走、不可带走物品 ' }
                        })}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>车送目的地址：</p>
                        <p>{data?.destination}</p>
                    </Space>
                </div>
                <div>
                    <Space>
                        <p>备注/异常：</p>
                        <p>{data?.other_exception}</p>
                    </Space>
                </div>
            </div>
        </div>}
    </div>
}